export const en = {
    'display-href-description':
        'A display link is the web address shown in your ad. We recommend using a link that is easy-to-read so that users understand where clicking the link will lead them.',
    'normal-view-title': 'Add display links to your ads',
    'normal-view-title-hint': 'Shown because you have ads without display links',
    'popup-view-title': 'Add a display link to your ad',
    'popup-view-title-hint': 'Shown because your ad has no display link',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads'
};
